import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { SeasonTimelineComponent } from './season-timeline/season-timeline.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-timeframe-card',
    templateUrl: './timeframe-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SeasonTimelineComponent, CommonModule, TranslateModule]
})
export class TimeframeCardComponent {
    public readonly title = input<string>();
    public readonly startDate = input<string | Date>();
    public readonly endDate = input<string | Date>();
    public readonly applicationDeadlineDate = input<string | Date>();
}
